import BaseComponent from '../base.js';

import * as btnStyles from './btn.module.scss';

export default class ControlButton extends BaseComponent {
  /** @type {boolean} */
  isPressed = false;

  /** @param {Props<HTMLButtonElement>} Props */
  constructor(Props) {
    super({ ...Props, elementTag: 'button', classes: [btnStyles.btn] });
    this.setPrivateListeners();
  }

  /**
   * Ads event listeners.
   * @returns {void}
   * @private
   */
  setPrivateListeners() {
    this.addListener('mousedown', this.handlePointerDown.bind(this));
    window.addEventListener('mouseup', this.handlePointerUp.bind(this));
    this.addListener('touchstart', this.handlePointerDown.bind(this), {
      passive: true,
    });
    window.addEventListener('touchend', this.handlePointerUp.bind(this));
    window.addEventListener('changeblock', this.handleChangeBlock.bind(this));
  }

  /**
   * Handles mouse button down. Starts the game.
   * @returns {void}
   * @private
   */
  handlePointerDown() {
    if (this.state.block) return;

    this.isPressed = true;
    this.addClasses(btnStyles.btnActive);
  }

  /**
   * Handles mouse button up.
   * @returns {void}
   * @private
   */
  handlePointerUp() {
    this.removeClasses(btnStyles.btnActive);

    setTimeout(() => {
      this.isPressed = false;
    }, 0);
  }

  /**
   * Handles changes in the state's block property.
   * @param {CustomEvent<StateObj>} e
   * @returns {void}
   * @protected
   */
  handleChangeBlock(e) {
    const { block } = e.detail;

    if (block) this.addClasses(btnStyles.btnBlocked);
    else this.removeClasses(btnStyles.btnBlocked);
  }
}
